import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { NavBar } from '../../components/NavBar'
import { getBlogPosts, type IBlogPostWithAuthor } from '../../api/blog'

export const BlogPage = () => {
  const navigate = useNavigate()
  const [posts, setPosts] = useState<IBlogPostWithAuthor[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    loadPosts()
  }, [])

  const loadPosts = async () => {
    try {
      setIsLoading(true)
      const result = await getBlogPosts(1, 50)
      setPosts(result.items)
    } catch (error) {
      console.error('Error loading blog posts:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const getExcerpt = (html: string, maxLength: number = 150) => {
    const text = html.replace(/<[^>]*>/g, '').trim()
    if (text.length <= maxLength) return text
    return text.substring(0, maxLength).trim() + '...'
  }

  return (
    <div className="min-h-screen bg-background">
      <NavBar />

      <div className="max-w-4xl mx-auto px-4 py-8 mt-20">
        <h1 className="text-4xl font-bold mb-8">Blog</h1>

        {isLoading ? (
          <div className="text-center text-gray-500 py-12">Loading...</div>
        ) : posts.length === 0 ? (
          <div className="text-center text-gray-500 py-12">
            <p className="text-lg">No blog posts yet</p>
          </div>
        ) : (
          <div className="space-y-6">
            {posts.map((post) => (
              <article
                key={post.id}
                onClick={() => navigate(`/blog/${post.slug}`)}
                className="flex gap-6 bg-white rounded-xl border border-searchBorder p-4 cursor-pointer hover:shadow-md transition-shadow"
              >
                {/* Image */}
                <div className="flex-shrink-0">
                  {post.coverImageUrl ? (
                    <img
                      src={post.coverImageUrl}
                      alt={post.title}
                      className="w-40 h-28 object-cover rounded-lg"
                    />
                  ) : (
                    <div className="w-40 h-28 bg-gray-100 rounded-lg flex items-center justify-center">
                      <span className="text-gray-400 text-sm">No image</span>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h2 className="text-xl font-semibold mb-2 line-clamp-2">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                    {getExcerpt(post.contentHtml)}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <span>{post.authorUsername}</span>
                    <span>•</span>
                    <time dateTime={post.created}>{formatDate(post.created)}</time>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
